import React, { useState, useEffect } from "react";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDelete } from "react-icons/md";

const Media = () => {
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const [images, setImages] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔹 Handle multiple image select
  const imgHandler = (e) => {
    setImages([...e.target.files]);
  };

  // 🔹 Upload images
  const btnHandler = async (e) => {
    e.preventDefault();

    if (images.length === 0) {
      return toast.error("Please select images");
    }

    try {
      const formData = new FormData();

      images.forEach((img) => {
        formData.append("image", img);
      });

      const res = await axios.post(
        `http://localhost:3232/api/v1/media`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success(res.data.message);
      setImages([]);
      getMedia();
    } catch (err) {
      console.log(err);
      toast.error("Upload failed");
    }
  };

  // 🔹 Get list
  const getMedia = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`http://localhost:3232/api/v1/media`);
      setData(res.data.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
      toast.error("Failed to fetch media");
    }
  };

  useEffect(() => {
    getMedia();
  }, []);

  // 🔹 Delete
  const deleteHandler = async (id) => {
    const confirm = window.confirm("Delete this image?");
    if (!confirm) return;

    try {
      await axios.delete(`${base_url}/api/v1/media/${id}`);
      toast.success("Deleted successfully");
      getMedia();
    } catch (err) {
      console.log(err);
      toast.error("Delete failed");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">

            {/* 🔥 Upload Form */}
            <div className="card mb-4">
              <div className="card-body">
                <form onSubmit={btnHandler}>
                  <div className="form-group">
                    <label>Upload Media (Multiple)</label>
                    <input
                      type="file"
                      className="form-control"
                      multiple
                      accept="image/*"
                      onChange={imgHandler}
                    />
                  </div>

                  <div className="form-group mt-3">
                    <input
                      type="submit"
                      value="Upload"
                      className="btn btn-primary"
                    />
                  </div>
                </form>
              </div>
            </div>

            {/* 🔥 List Table */}
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered shadow-sm">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Mobile Image</th>
                        <th>Desktop Image</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading && (
                        <tr>
                          <td colSpan="4">
                            <Skeleton count={3} />
                          </td>
                        </tr>
                      )}

                      {data.length > 0 ? (
                        data.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>

                            <td>
                              <img
                                src={item.mobile_image}
                                style={{
                                  height: "60px",
                                  borderRadius: "8px",
                                }}
                              />
                            </td>

                            <td>
                              <img
                                src={item.desktop_image}
                                style={{
                                  height: "60px",
                                  borderRadius: "8px",
                                }}
                              />
                            </td>

                            <td>
                              <MdDelete
                                size={24}
                                style={{ color: "red", cursor: "pointer" }}
                                onClick={() => deleteHandler(item.id)}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        !loading && (
                          <tr>
                            <td colSpan="4" className="text-center text-danger">
                              No data found
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>

                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Media;